<template>
  <article class="solution-root-cause py-4 px-5 mb-4">
    <p class="solution-root-cause__name">
      <b>{{ $t('problem_solving.improve.root_cause_title') }} </b>
      <span data-testid="root-cause-name">{{ name }}</span>
    </p>
    <p class="solution-root-cause__name font-size-14 text-ui-500  caption">
      <span data-testid="root-cause-type">{{ type }}</span>
    </p>
    <p class="solution-root-cause__analysis font-size-14 text-ui-600">
      <span data-testid="root-cause-description">{{ description }}</span>
    </p>
  </article>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: true,
    },
  },
}
</script>
>

<style lang="scss" scoped>
.solution-root-cause {
  background-color: $color-blue-grey-lighten3;
  border-radius: 4px;

  &__name,
  &__type {
    line-height: 17px;
    width: calc(50% - 8px);

    span {
      overflow-wrap: break-word;
    }
  }

  &__analysis {
    width: 100%;
  }
}
</style>
